// tslint:disable:max-line-length
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { E5coreUiWorkFieldTypeBase } from '../e5core-ui-work-field/e5core-ui-work-field-type-base';
import { WorkFieldCurrencyChangeEvent } from '../../events/work-field-currency-change-event';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-currency',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-currency-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' [pattern]='pattern' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-currency-box>
    <e5core-ui-work-field-type-currency-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' [pattern]='pattern' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-currency-bootstrap>
    <e5core-ui-work-field-type-currency-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' [pattern]='pattern' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-currency-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeCurrencyComponent extends E5coreUiWorkFieldTypeBase {

  @Input() pattern: string ;

  constructor(public style:UiStyleService) {
    super() ;
  }

  valueChange($event: WorkFieldCurrencyChangeEvent) {
    this.dispatchPropertyChange(this.property.propertyId, ($event.value || "").toString(), $event.error);
    return ;
  }

}
